import React, { useEffect, useRef, useState } from "react";
import { getDOY, _common } from "../../common";
import { ServerInterface } from "../../ServerInterface";
import moment from "moment";
import WellcomeOneRect, { OneMember } from "./WelcomeOneRect";
import QRCode from "react-qr-code";

const common = _common;

function Footer() {
  return (
    <div style={{ display: "flex", flexDirection: "row", borderTop: "1px solid lightgrey" }}>
      <div style={{ padding: "5px" }}>
        <QRCode value="app.tc-kreuzberg.de/profile" size={40} />
      </div>

      <div style={{ display: "flex", fontSize: "0.7em", flexGrow: "1", justifyContent: "center", alignItems: "center" }}>
        Um Dein Profilbild zu erstellen, <br />
        tippe in der App oben rechts auf Dein Profil. <br />
        Die App muß dazu gegenfalls neu installiert werden.
      </div>
      <img style={{ height: "50px" }} src="/images/Header.jpeg" />
    </div>
  );
}
export default function Welcome(props: {}) {
  const lastFetch = useRef<number>(0);

  const rectsRef = useRef<HTMLDivElement>(null);

  let [bookings, setBookings] = useState<any>([]);

  async function fetchBookingsFromServer(d: Date) {
    // modifiziere das Datum auf 3 uhr morgens ab gleichen tag
    // und Unterschiede in der Zeitzone das DAtum irrelevat zu machen.
    //
    // 3.3.2023  00:00 ist in UTZ 2.3.2023 22:00
    // Das führ dazu das der Server (fall er in UTC) läuft ein falsches DOY (exhtes DOY-1) liefern würde!!!
    //
    // ab 30.3.2023 versuche ich den Server hart auf 'Europe/Amsterdam' zu setzen
    // process.env.TZ = 'Europe/Amsterdam'

    const d1 = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 3, 0);

    const queryData = {
      date: d1,
      anzeigeTafelMode: common.anzeigeTafelMode,
      numdays: 1,
    };

    let multiDayBookings = await ServerInterface.getbookings(queryData);

    if (multiDayBookings) {
      let dayBookings = multiDayBookings[getDOY(d)];
      if (dayBookings) {
        dayBookings = dayBookings.sort((a: any, b: any) => {
          const aa = `${a.date} ${7 - a.court}`;
          const bb = `${b.date} ${7 - b.court}`;
          return bb.localeCompare(aa);
        });
        setBookings(dayBookings);
        lastFetch.current = new Date().getTime();
      } else {
        console.error("error loading bookings");
      }
    }
  }

  useEffect(() => {
    fetchBookingsFromServer(new Date());
  }, []);

  const rects: any = [];
  const rectsTerrasse: any = [];
  const rectsBald: any = [];

  const numHours = common.lastHourOfDay - common.firstHourOfDay;

  //
  // overlay bookings
  //

  let lastDate = "";

  bookings = bookings.sort((a: any, b: any) => {
    return a.court < b.court ? -1 : 1;
  });

  let personoen_wirWartenAuf: any = [];
  let personen_aufDerTerrasse: any = [];

  for (var b = 0; b < bookings.length; b++) {
    const booking = bookings[b];

    const d1 = new Date(booking.date);
    const bookingStarttime = moment(d1);
    const bookingEndtime = moment(d1);

    bookingEndtime.add(booking.numHours || 1, "hour");

    const now = new Date();

    // for debugging !!!!!!!!!!!!!!!!!!!!
    // now.setHours(17);
    // now.setMinutes(40);
    // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

    const mnow = moment(now);
    const mnow2 = moment(now).add(15, "minutes");

    const mnow3 = moment(now).subtract(30, "minutes");
    const mnow4 = moment(now).subtract(90, "minutes");

    const buchungKommtBald = bookingStarttime.isBetween(mnow, mnow2);
    const buchungIstVorbei = bookingEndtime.isBefore(mnow);

    const spieltJetzt = mnow.isBetween(bookingStarttime, bookingEndtime);

    const buchungLaeuft = bookingStarttime.isBefore(mnow) && bookingEndtime.isAfter(mnow);

    const sitztAufDerTerrasse = bookingEndtime.isBetween(mnow4, mnow);

    let showThisBooking = buchungKommtBald || buchungIstVorbei || buchungLaeuft || sitztAufDerTerrasse;

    showThisBooking &&= booking.partners?.length > 0;

    let statusColor = "blue";

    if (buchungKommtBald) {
      statusColor = "yellowgreen";
    }
    if (buchungLaeuft) {
      statusColor = "green";
    }

    if (buchungIstVorbei) {
      statusColor = "red";
    }

    console.log(`${showThisBooking} ${mnow} < ${bookingStarttime} < ${mnow2}`);
    if (showThisBooking) {
      console.log(`show`, booking);

      const partner0 = booking.partners[0];
      let bookingId0 = -1;
      if (partner0) {
        bookingId0 = parseInt(partner0.split(";"));
      }

      if (bookingId0 > 10) {
        const key = `rf-${booking.court}-${new Date(booking.date).getHours()}`;

        if (buchungKommtBald) {
          for (var p of booking.partners) {
            personoen_wirWartenAuf.push(p);
          }
        } else if (spieltJetzt) {
          rects.push(
            <WellcomeOneRect
              key={key}
              firstOneWithThisTime={booking.date != lastDate}
              booking={booking}
              statusColor={statusColor}
              sitztAufDerTerrasse={sitztAufDerTerrasse} />
          );
        } else if (sitztAufDerTerrasse) {
          for (var p of booking.partners) {
            personen_aufDerTerrasse.push(p);
          }
        }

        lastDate = booking.date;
      }
    }
  }

  function sortPlayer(a: any, b: any) {
    const aVorname = a.split(";")[1].split(" ")[0];
    const bVorname = b.split(";")[1].split(" ")[0];
    return aVorname.localeCompare(bVorname);
  }

  personoen_wirWartenAuf = personoen_wirWartenAuf.sort(sortPlayer);
  personen_aufDerTerrasse = personen_aufDerTerrasse.sort(sortPlayer);

  for (let partner of personoen_wirWartenAuf) {
    let partnerName: string = partner.split(";")[1];
    if (partnerName) {
      const memberFirstname = partnerName.split(" ")[0];
      partnerName = partnerName.substring(memberFirstname.length).trim();
      rectsBald.push(<OneMember
        key={partner.split(";")[0]}
        memberId={partner.split(";")[0]}
        memberFirstname={memberFirstname}
        memberName={partnerName} />);
    }
  }

  for (let partner of personen_aufDerTerrasse) {
    let partnerName: string = partner.split(";")[1];
    if (partnerName) {
      const memberFirstname = partnerName.split(" ")[0];
      partnerName = partnerName.substring(memberFirstname.length).trim();
      rectsTerrasse.push(<OneMember
        key={partner.split(";")[0]}
        memberId={partner.split(";")[0]}
        memberFirstname={memberFirstname}
        memberName={partnerName} />);
    }
  }

  const rows: any = [];

  for (let i = 0; i < rects.length; i = i + 3) {
    rows.push(
      <div style={{ position: "relative", display: "flex", flexDirection: "row", width: "100%", height: "max-content" }}>
        {rects[i]}
        {rects[i + 1]}
        {rects[i + 2]}
      </div>
    );
  }

  return (
    <div
      style={{
        position: "relative",
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
        borderRadius: "10px",
        overflow: "hidden",
        backgroundColor: "white",
        fontSize: "16px",
      }}
    >
      <div
        ref={rectsRef}
        id="rects"
        style={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          width: "100%",
          height: "100%",
          // overflow: "hidden",
        }}
      >
        <div
          id="pureRects"
          style={{
            position: "relative",
            display: "flex",
            flexDirection: "column",
            width: "100%",
            height: "100%",
          }}
        >
          {rows.length > 0 && (
            <div
              style={{
                position: "relative",
                flexShrink: "0",
                width: "100%",
                paddingTop: "10px",
                paddingBottom: "10px",
                paddingLeft: "20px",
                overflow: "hidden",
                color: "black",
                backgroundColor: "lightgray",
                textAlign: "left",
              }}
            >
              Wir heißen herzlich willkommen ... es spielen jetzt
            </div>
          )}
          {rects.length > 0 && (
            <div
              style={{ flexShrink: "0", display: "flex", flexDirection: "row", justifyContent: "space-between", flexFlow: "wrap", padding: "10px", backgroundColor: "lightgreen" }}
            >
              {rects}
            </div>
          )}

          {rectsBald.length > 0 && (
            <div
              style={{
                position: "relative",
                flexShrink: "0",
                width: "100%",
                paddingTop: "10px",
                paddingBottom: "10px",
                paddingLeft: "20px",
                overflow: "hidden",
                color: "black",
                backgroundColor: "lightgray",
                textAlign: "left",
              }}
            >
              ... gleich gehen auf den Platz
            </div>
          )}
          {rectsBald.length > 0 && (
            <div style={{ flexShrink: "0", display: "flex", flexDirection: "row", justifyContent: "space-between", flexFlow: "wrap", padding: "10px" }}>{rectsBald}</div>
          )}

          {rectsTerrasse.length > 0 && (
            <div
              style={{
                flexShrink: "0",
                position: "relative",
                width: "100%",
                paddingTop: "10px",
                paddingBottom: "10px",
                paddingLeft: "20px",
                overflow: "hidden",
                color: "black",
                textAlign: "left",
                backgroundColor: "lightgray",
              }}
            >
              ... es sitzen vielleicht noch auf der Terrasse
            </div>
          )}
          {rectsTerrasse.length > 0 && (
            <div style={{ flexShrink: "0", display: "flex", flexDirection: "row", justifyContent: "space-between", flexFlow: "wrap", padding: "10px" }}>{rectsTerrasse}</div>
          )}

          <div style={{ flexGrow: "1", height: "2px" }}> &nbsp;</div>
          <Footer />
        </div>
      </div>
    </div>
  );
}
